import { makeStyles } from '@material-ui/styles';
import clouds from './images/clouds.svg';
import coast from './images/coast.svg';
import water from './images/water.svg';
import bigWave from './images/bigWave.svg';
import unionWave from './images/unionWave.svg';
import smallWave from './images/smallWave.svg';
import forest from './images/forest.svg';
import city from './images/city.png';
import illustration from './images/illustration.png';
import cloud1 from './images/cloud1.svg';
import cloud2 from './images/cloud2.svg';
import cloud3 from './images/cloud3.svg';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100vh',
    minHeight: 500,
    position: 'relative',
    [theme.breakpoints.up('lg')]: {
      overflowX: 'hidden',
    },
  },
  mobile: {
    height: '100%',
    backgroundImage: `url(${illustration})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'bottom',
    backgroundSize: 'auto 45%',
    opacity: '.3',
    [theme.breakpoints.up('lg')]: {
      display: 'none',
      backgroundImage: 'none',
      overflowX: 'hidden',
    },
  },
  desktop: {
    display: 'none',
    opacity: '.3',
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
      backgroundImage: 'none',
      overflowX: 'hidden',
    },
  },
  clouds: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    backgroundImage: `url(${cloud1}), url(${cloud2}), url(${cloud3})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 10% top 20%, left 10% top 15%, right 20% top 40%',
    [theme.breakpoints.up('lg')]: {
      backgroundImage: `url(${clouds})`,
      backgroundRepeat: 'repeat-x',
      height: '55vh',
      backgroundSize: '2589px 53vh',
      backgroundPosition: '2589px bottom',
      position: 'absolute',
      width: '100%',
      animation: `$cloud 100s linear infinite`,
    },
  },
  water: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      backgroundImage: `url(${water})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'bottom',
      backgroundSize: 'cover',
      width: '2806px',
      height: '12vh',
      position: 'absolute',
      bottom: 0,
      display: 'flex',
      left: '50%',
      transform: 'translateX(-50%)',
      padding: [0, 100],
    },
  },
  wave: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      display: 'block',
      flexGrow: 1,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'top 40% center',
      backgroundSize: 'auto 52%',
      height: '50%',
      animation: `$wave 7s ease infinite`,
      '&:nth-child(1), &:nth-child(4)': {
        backgroundImage: `url(${unionWave})`,
      },
      '&:nth-child(3), &:nth-child(5)': {
        backgroundImage: `url(${bigWave})`,
      },
      '&:nth-child(2)': {
        backgroundImage: `url(${smallWave})`,
        backgroundSize: 'auto 32%',
      },
      '&:nth-child(2), &:nth-child(4)': {
        animationDelay: '3s',
      },
    },
  },
  coast: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      display: 'block',
      width: 2806,
      height: '10vh',
      backgroundImage: `url(${coast})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'bottom',
      backgroundSize: 'auto 10vh',
      position: 'absolute',
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
    },
  },

  forest: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      display: 'block',
      backgroundImage: `url(${forest})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'bottom',
      backgroundSize: 'auto 27vh',
      width: 2427,
      height: '27vh',
      bottom: '12vh',
      position: 'absolute',

      left: '50%',
      transform: 'translateX(-50%)',
    },
  },
  city: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      display: 'block',
      backgroundImage: `url(${city})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'bottom',
      position: 'absolute',
      bottom: 'calc(12vh + -1px)',
      width: 1034,
      height: '22vh',
      backgroundSize: 'auto 22vh',
      transform: 'translateX(-50%)',
    },
  },

  '@keyframes cloud': {
    from: {
      backgroundPosition: '2589px bottom',
    },
    to: {
      backgroundPosition: '0 bottom',
    },
  },
  '@keyframes wave': {
    '0%': {
      transform: 'translateY(0%)',
    },
    '50%': {
      transform: 'translateY(35%)',
    },
    '100%': {
      transform: 'translateY(0%)',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/NonAuthHomePage/components/Banner/components/Background/useStyles.js